// extracted by mini-css-extract-plugin
module.exports = {"container":"spinnerAlt_container__3QbRJ"};
    if(module.hot) {
      // 1790670303899
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  